import { actionTypes as baseActionTypes } from '@core/js/hooks/useGetJackpots/store/constants';

export enum JACKPOTS_TYPES {
    JACKPOTS = 'jackpots',
    GREEN_TUBE_JACKPOTS = 'greenTubeJackpots',
    SKY_WIND_JACKPOT = 'skyWindJackpots',
    VF_JACKPOTS = 'vfJackpots'
}

export const JACKPOT_KEYS = {
    [JACKPOTS_TYPES.JACKPOTS]: JACKPOTS_TYPES.JACKPOTS,
    [JACKPOTS_TYPES.GREEN_TUBE_JACKPOTS]: JACKPOTS_TYPES.GREEN_TUBE_JACKPOTS,
    [JACKPOTS_TYPES.SKY_WIND_JACKPOT]: JACKPOTS_TYPES.SKY_WIND_JACKPOT,
    [JACKPOTS_TYPES.VF_JACKPOTS]: JACKPOTS_TYPES.JACKPOTS
};

export const actionTypes = { ...baseActionTypes };
